import app from './app/types';
import user from './user/types';
import games from './games/types';
import modals from './modals/types';
import wallet from './wallet/types';
import vip from './vip/types';
import vip20 from './vip20/types';
import wheel from './wheel/types';
import invite from './invite/types';
import tasks from './tasks/types';
import modals_action from './modals-action/types';
import notifications from './notifications/types';
import lucky_wheel from './lucky-wheel/types';

export default {
    app,
    user,
    games,
    modals,
    wallet,
    vip,
    vip20,
    wheel,
    invite,
    tasks,
    modals_action,
    notifications,
    lucky_wheel
}